import { Expose } from "class-transformer";

export default class Form {
  @Expose() id: number;
  @Expose() idef: string;
  @Expose() name: string;
  @Expose() dom: string;
}
